import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { LandingHeader } from "./landing/LandingHeader";
import { SiteFooter } from "./SiteFooter";

// Shared frame for editorial / trust pages: header, breadcrumb trail, footer.
export function PublicPageShell({ crumbs = [], children, testId = "public-page" }) {
  return (
    <div className="min-h-screen bg-[#030206] text-white" data-testid={testId}>
      <LandingHeader lifetimeHref="/pricing" />
      <main className="mx-auto max-w-5xl px-4 pb-24 pt-10 sm:px-6 md:px-10">
        {crumbs.length > 0 && (
          <nav aria-label="Breadcrumb" className="mb-8 flex flex-wrap items-center gap-1 text-xs text-zinc-500" data-testid="breadcrumbs">
            <Link to="/" className="hover:text-purple-300">Home</Link>
            {crumbs.map((c, i) => (
              <span key={c.href || c.label} className="inline-flex items-center gap-1">
                <ChevronRight size={12} aria-hidden="true" />
                {c.href && i < crumbs.length - 1 ? <Link to={c.href} className="hover:text-purple-300">{c.label}</Link> : <span className="text-zinc-300" aria-current="page">{c.label}</span>}
              </span>
            ))}
          </nav>
        )}
        {children}
      </main>
      <SiteFooter />
    </div>
  );
}

export function PageIntro({ kicker, title, lede }) {
  return (
    <header className="max-w-3xl">
      {kicker && <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-purple-300">{kicker}</div>}
      <h1 className="mt-4 font-display text-4xl font-black leading-[1.02] sm:text-5xl lg:text-6xl">{title}</h1>
      {lede && <p className="mt-6 text-base leading-relaxed text-zinc-300 md:text-lg">{lede}</p>}
    </header>
  );
}

export function Prose({ children, className = "" }) {
  return <div className={`mt-10 space-y-5 text-base leading-relaxed text-zinc-300 [&_h2]:mt-12 [&_h2]:font-display [&_h2]:text-2xl [&_h2]:font-black [&_h2]:text-white [&_h3]:mt-6 [&_h3]:font-semibold [&_h3]:text-white [&_ul]:list-disc [&_ul]:space-y-1.5 [&_ul]:pl-6 [&_a]:text-purple-300 [&_a]:underline [&_a]:underline-offset-4 ${className}`}>{children}</div>;
}
